export default __webpack_public_path__ + "static/media/icon-profil.76a0cf05.svg";